import { render, staticRenderFns } from "./Nation.vue?vue&type=template&id=59d52b6a&scoped=true"
import script from "./Nation.vue?vue&type=script&lang=js"
export * from "./Nation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d52b6a",
  null
  
)

export default component.exports